"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _index = _interopRequireDefault(require("@/views/caseConditions/index.vue"));
var _inquiry = require("@/api/inquiry.js");
var _dictionary = require("@/config/dictionary");
var _send = _interopRequireDefault(require("../../case/service/send"));
var _index2 = require("@/utils/index.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'division',
  data: function data() {
    return {
      tableHeaderColor: this.$tableHeaderColor,
      loading: true,
      currentPage: 1,
      pageLimit: 10,
      //每页请求多少个数据，默认10
      pageSizes: this.$tablePageSizes,
      tableData: [],
      secretaryList: [],
      total: 0,
      //总页数
      conditionData: '',
      //来自子组件的数据
      caseState: _dictionary.dictionary.caseState,
      multipleSelection: [],
      multipleSelectionId: [],
      wayList: [{
        name: '书面审理',
        id: '1'
      }, {
        name: '线下开庭',
        id: '2'
      }, {
        name: '视频开庭',
        id: '3'
      }],
      divisionLotVisible: false,
      //案件组庭批量弹窗显示
      divisionLotForm: {
        //案件组庭批量数据
        chiefArbitratorId: "",
        chiefArbitratorName: '',
        trialWay: ''
      },
      divisionLotRules: {
        chiefArbitratorId: [{
          required: true,
          message: '请选择首席仲裁员',
          trigger: 'change'
        }],
        trialWay: [{
          required: true,
          message: '请选择审理方式',
          trigger: 'change'
        }],
        secretaryId: [{
          required: true,
          trigger: 'change',
          message: '请选择处理人'
        }],
        opinion: [{
          required: true,
          trigger: 'blur',
          message: '请填写意见'
        }]
      },
      divisionRules: {
        secretaryId: [{
          required: true,
          trigger: 'change',
          message: '请选择处理人'
        }],
        opinion: [{
          required: true,
          trigger: 'blur',
          message: '请填写意见'
        }]
      },
      divisionVisible: false,
      //案件组庭弹窗显示
      divisionForm: {
        //案件组庭数据
        chiefArbitratorId: "",
        chiefArbitratorName: '',
        secondArbitratorId: '',
        secondArbitratorName: '',
        thirdArbitratorId: '',
        thirdArbitratorName: '',
        trialWay: ''
      },
      // divisionRules: {
      //   chiefArbitratorId: [
      //     {required: true, message: '请选择首席仲裁员', trigger: 'change'}
      //   ],
      //   trialWay: [
      //     {required: true, message: '请选择审理方式', trigger: 'change'}
      //   ],
      // },
      caseId: '',
      caseNum: '',
      node: '',
      arbitratorList: [],
      partyChoiceArb: {
        appArbitratorName: '',
        resArbitratorName: '',
        content: '',
        replyName: '',
        href: '',
        secretaryId: '',
        opinion: '',
        secretaryName: ''
      },
      allLoading: false,
      //全屏loading
      sendCaseVisible: false,
      //案件送达
      gotoServicing: false,
      //选定仲裁员弹窗 按钮loading

      loadingProcess: false,
      sumbiting: false,
      //批量审核中
      optionArr: [],
      processVisible: false,
      opinionform: {
        reviewId: "",
        reviewName: "",
        opinion: ""
      },
      refuseRules: {
        reviewId: [{
          required: true,
          message: '请选择人员',
          trigger: 'change'
        }],
        opinion: [{
          required: true,
          message: '请输入审核意见',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.init();
  },
  components: {
    Caseconditons: _index.default
  },
  methods: {
    handleProcess: function handleProcess() {
      var _this = this;
      this.$refs.opinionform.validate(function (valid) {
        if (valid) {
          var params = _this.opinionform;
          var optAr = _this.optionArr.find(function (item) {
            return item.id == _this.opinionform.reviewId;
          });
          params.reviewName = optAr.name;
          _this.loadingProcess = true;
          (0, _inquiry.batchTask)({
            caseIds: _this.onGetBatchIds(),
            caseState: 2,
            content: JSON.stringify(params)
          }).then(function (res) {
            if (res.code == 1) {
              _this.sumbiting = false;
              _this.$message({
                message: '批量操作成功',
                type: 'success'
              });
              _this.caseBriefVisible = false;
              _this.init();
              _this.processVisible = false;
            } else {
              _this.$message.error(res.msg);
              _this.processVisible = false;
            }
          });

          // onBatchSendRegisterPayBook(params).then(res=>{
          //   this.loadingProcess=false;
          //   if(res.code=='1'){
          //     this.init();
          //     this.processVisible=false;
          //      this.$message({ message: "操作成功", type: "success" });
          //   }else{
          //      this.$message({ message: "操作失败", type: "error" });
          //   }
          // }).catch(error=>{
          //   this.loadingProcess=false;
          // });
        } else {
          return;
        }
      });
    },
    onGetBatchIds: function onGetBatchIds() {
      var ids = [];
      for (var i = 0; i < this.multipleSelection.length; i++) {
        var item = this.multipleSelection[i];
        ids.push(item.caseId);
      }
      return ids;
    },
    onloadProcessMan: function onloadProcessMan() {
      var _this2 = this;
      this.caseId = this.multipleSelection[0].caseId;
      (0, _inquiry.getSecretaryList)({
        id: this.caseId
      }).then(function (res) {
        if (res.code == 1) {
          var data = res.data.length ? res.data[0].allReviews : [];
          _this2.optionArr = data;
        }
      });
    },
    init: function init() {
      var _this3 = this;
      (0, _inquiry.getList)({
        state: '2',
        limit: this.pageLimit,
        page: this.currentPage
      }).then(function (res) {
        if (res.code == 1) {
          _this3.tableData = res.rows;
          _this3.total = res.total;
          _this3.loading = false;
          _this3.gotoServicing = false;
        }
      });
    },
    handleDetail: function handleDetail(val) {
      this.$router.push({
        name: 'inquiryDetail',
        params: {
          caseId: val
        }
      });
    },
    //点击筛选，发送请求列表
    checkList: function checkList(data) {
      var _this4 = this;
      // 需要发送给后端的数据
      this.currentPage = 1;
      var postData = {
        caseId: data.caseId,
        caseNo: data.caseNo,
        partyName: data.partyName,
        defenceState: data.replyvalue,
        beginCtime: data.rowSecondDate[0],
        endCtime: data.rowSecondDate[1],
        caseType: data.caseTypevalue,
        beginRegisterTime: data.rowThirdDate[0],
        endRegisterTime: data.rowThirdDate[1],
        source: data.caseOriginvalue,
        state: '2',
        limit: this.pageLimit,
        page: 1
      };
      this.conditionData = postData;
      (0, _inquiry.getList)(this.conditionData).then(function (res) {
        if (res.code == 1) {
          _this4.tableData = res.rows;
          _this4.total = res.total;
        }
      });
    },
    //点击 清空所有筛选条件
    cleanConditionData: function cleanConditionData() {
      this.conditionData = '';
      this.currentPage = 1;
      this.init();
    },
    //表格禁止勾选事件
    selectable: function selectable(row, index) {
      if (row.arbitratorName) {
        return true;
      } else {
        return false;
      }
    },
    // 表格勾选事件
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getSecretaryListInfo: function getSecretaryListInfo(data) {
      var _this5 = this;
      (0, _inquiry.getSecretaryList)({
        id: data
      }).then(function (res) {
        if (res.code == 1) {
          _this5.secretaryList = res.data[0].allReviews;
          _this5.partyChoiceArb.opinion = res.data[0].content;
          _this5.partyChoiceArb.secretaryName = _this5.secretaryList[0].name;
          _this5.partyChoiceArb.secretaryId = _this5.secretaryList[0].id;
        } else {
          _this5.$message({
            message: res.msg,
            type: 'error'
          });
        }
      }).catch(function (error) {});
    },
    //已选择仲裁员
    getChoiceArbitrator: function getChoiceArbitrator(data) {
      var _this6 = this;
      (0, _inquiry.getChoiceArbitrator)(data).then(function (res) {
        if (res.code == 1) {
          _this6.partyChoiceArb.appArbitratorName = res.data.appArbitratorName;
          _this6.partyChoiceArb.resArbitratorName = res.data.resArbitratorName;
          _this6.partyChoiceArb.content = res.data.content;
          _this6.partyChoiceArb.replyName = res.data.replyName;
        }
      });
      this.getSecretaryListInfo(data);
    },
    handleReview: function handleReview(data) {
      var _this7 = this;
      this.caseId = data.caseId;
      this.allLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.sendCaseVisible = true;
      this.$nextTick(function () {
        _this7.$refs.sendCase.init(_this7.caseId, 2);
      });
    },
    //查看
    handleCheck: function handleCheck(data) {
      this.caseId = data.caseId;
      this.node = data.node;
      this.divisionVisible = true;
      this.getChoiceArbitrator(this.caseId);
    },
    updateShow: function updateShow() {
      this.divisionVisible = false;
      this.sendCaseVisible = true;
      this.gotoServicing = false;
      if (!this.fullscreenLoading) {
        this.fullscreenLoading = false;
      }
    },
    updateErrorShow: function updateErrorShow() {
      this.sendCaseVisible = false;
      this.gotoServicing = false;
    },
    // 审核通过后刷新数据
    refreshPage: function refreshPage() {
      this.sendCaseVisible = false;
      this.init();
    },
    //进行组庭
    caseCourtAdopt: function caseCourtAdopt() {
      var _this8 = this;
      this.$refs.reviewForm.validate(function (valid) {
        if (valid) {
          _this8.gotoServicing = true;
          _this8.secretaryList.forEach(function (item) {
            if (item.id == _this8.partyChoiceArb.secretaryId) {
              _this8.partyChoiceArb.secretaryName = item.name;
            }
          });
          (0, _inquiry.procedureByAdopt)({
            caseId: _this8.caseId,
            node: _this8.node,
            reviewId: _this8.partyChoiceArb.secretaryId,
            reviewName: _this8.partyChoiceArb.secretaryName,
            content: _this8.partyChoiceArb.opinion
          }).then(function (res) {
            if (res.code == 1) {
              _this8.$message({
                message: '进行组庭成功',
                type: 'success'
              });
              _this8.divisionVisible = false;
              _this8.gotoServicing = false;
              _this8.init();
            }
          });
        } else {
          _this8.gotoServicing = false;
        }
      });
    },
    //批量审核
    batchReview: function batchReview() {
      if (!this.multipleSelection || this.multipleSelection.length <= 0) {
        this.$message({
          message: "请勾选案件",
          type: "waring"
        });
        return;
      }
      this.opinionform.reviewId = '';
      this.opinionform.reviewName = '';
      this.opinionform.opinion = '通过';
      this.processVisible = true;
      this.onloadProcessMan();

      // this.caseNum = this.multipleSelectionId.length;
      // this.$confirm('确定批量审核？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.multipleSelectionId = [];
      //   this.multipleSelection.forEach(item => {
      //     this.multipleSelectionId.push(item.caseId);
      //   })
      //   batchProcedureByAdopt({caseIds: this.multipleSelectionId}).then((res) => {
      //     if (res.code == 1) {
      //       this.$message({message: '批量审核成功', type: 'success'});
      //       this.init();
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //   })
      // })
    },
    batchReviewSubmit: function batchReviewSubmit(divisionLotForm) {
      var _this9 = this;
      this.$refs[divisionLotForm].validate(function (valid) {
        if (valid) {
          _this9.arbitratorList.forEach(function (item) {
            if (item.id == _this9.divisionLotForm.chiefArbitratorId) {
              _this9.divisionLotForm.chiefArbitratorName = item.name;
            }
          });
          _this9.divisionLotForm.caseIds = _this9.multipleSelectionId;
          (0, _inquiry.batchSendCompose)(_this9.divisionLotForm).then(function (res) {
            if (res.code == 1) {
              _this9.$message({
                message: '批量审核成功',
                type: 'success'
              });
              _this9.divisionLotVisible = false;
              _this9.init();
              // 批量送达页面？？？
            } else {
              _this9.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      var _this10 = this;
      this.pageLimit = val;
      if ((0, _index2.hasValueInObj)(this.conditionData)) {
        // 有筛选条件的情况下
        this.conditionData.limit = val;
        this.conditionData.page = this.currentPage;
        (0, _inquiry.getList)(this.conditionData).then(function (res) {
          if (res.code == 1) {
            _this10.tableData = res.rows;
            _this10.total = res.total;
          }
        });
      } else {
        //没有筛选条件的情况下
        (0, _inquiry.getList)({
          state: '2',
          limit: val,
          page: this.currentPage
        }).then(function (res) {
          if (res.code == 1) {
            _this10.tableData = res.rows;
            _this10.total = res.total;
          }
        });
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      var _this11 = this;
      if ((0, _index2.hasValueInObj)(this.conditionData)) {
        // 有筛选条件的情况下
        this.conditionData.page = val;
        this.conditionData.limit = this.pageLimit;
        (0, _inquiry.getList)(this.conditionData).then(function (res) {
          if (res.code == 1) {
            _this11.tableData = res.rows;
            _this11.total = res.total;
            _this11.currentPage = val;
          }
        });
      } else {
        //没有筛选条件的情况下
        (0, _inquiry.getList)({
          state: '2',
          limit: this.pageLimit,
          page: val
        }).then(function (res) {
          if (res.code == 1) {
            _this11.tableData = res.rows;
            _this11.total = res.total;
            _this11.currentPage = val;
          }
        });
      }
    }
  }
};
exports.default = _default;